//@flow
import {ActionCreator, createReducer} from '../../store/utils';

import type {ProductBatchLoadTask} from '../../entities';

export type ProductBatchUploadActions = {
  batchTaskUpdate?: ProductBatchLoadTask,
  batchTaskCreate?: ProductBatchLoadTask,
};

export type ProductBatchUploadState = {
  batchTaskUpdate?: ProductBatchLoadTask,
  batchTaskCreate?: ProductBatchLoadTask,
};

export class ProductBatchUploadActionCreator extends ActionCreator<ProductBatchUploadActions> {}

export const actions = {
  setBatchTaskUpdate: (batchTaskUpdate: ProductBatchLoadTask) =>
    new ProductBatchUploadActionCreator({
      batchTaskUpdate,
    }),

  setBatchTaskCreate: (batchTaskCreate: ProductBatchLoadTask) =>
    new ProductBatchUploadActionCreator({
      batchTaskCreate,
    }),
};

export const initialState: ProductBatchUploadState = {};

export default createReducer(initialState, {
  [ProductBatchUploadActionCreator.type]: (
    state: ProductBatchUploadState,
    action: ProductBatchUploadActions
  ): ProductBatchUploadState => {
    return {
      ...state,
      ...action,
    };
  },
});
